import { Field, TextInput } from "@nabble/ui";
import type { NewPersonForm } from "../hooks/useNewPersonForm";

/** The "Full name" and "Email" fields of an invitation form. */
export function NewPersonFields({ form }: { form: NewPersonForm }): React.JSX.Element {
  return (
    <>
      <Field label="Full name">
        <TextInput value={form.displayName} onChange={(e) => form.setDisplayName(e.target.value)} autoComplete="off" placeholder="E.g. Emma Clarke" />
      </Field>
      <Field label="Email" error={form.emailError ?? undefined}>
        <TextInput
          type="email"
          icon="mail"
          value={form.email}
          onChange={(e) => form.setEmail(e.target.value)}
          autoComplete="off"
          autoCapitalize="none"
          spellCheck={false}
          placeholder="name@company.cl"
        />
      </Field>
    </>
  );
}
